import getEnvironment from 'utils/getEnvironment'
import type { RedirectStatus } from './utils'

export default function stopOnLocal(): RedirectStatus {
  const environment = getEnvironment()
  return {
    continue: environment !== 'local'
  }
}
